import React, { Component } from "react";
import { Link } from "react-router-dom";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as UsersActions,
  Selectors as UsersSelectors,
} from "store/ducks/users";

import { Form, Loading } from "components";

class GroupForm extends Component {
  state = {
    data: this.props.data,
  };

  constructor(props) {
    super(props);

    const { getUsersGroupsRequest } = this.props;

    this.handleSearchGroups = debounce(getUsersGroupsRequest, 300);
  }

  componentDidMount() {
    const { getUsersGroupsRequest } = this.props;
    getUsersGroupsRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleFindGroups = (value) => {
    this.handleSearchGroups(value);
  };

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleChangeInput = (e) => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleSelectGroups = (value) => {
    const { data } = this.state;

    this.setState({
      data: { ...data, user_groups_attributes: value },
    });
  };

  render() {
    const { data } = this.state;
    const { groups, errors, saving, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Usuário</h3>

        <Form.Field>
          <Form.Label>Nome</Form.Label>
          <Form.Input
            name="name"
            placeholder="Nome"
            value={data.name}
            errors={errors.name}
            onChange={this.handleChangeInput}
            readOnly
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>E-mail</Form.Label>
          <Form.Input
            name="email"
            placeholder="E-mail"
            value={data.email}
            errors={errors.email}
            onChange={this.handleChangeInput}
            readOnly
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Grupos</Form.Label>
          <Form.Select
            isMulti
            placeholder="Grupos"
            noOptionsMessage={() => "Procurar grupos"}
            options={groups.data}
            value={data.user_groups_attributes}
            onChange={this.handleSelectGroups}
            onInputChange={this.handleFindGroups}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/configs/users" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button
            className="button-save"
            onClick={onSubmit}
            disabled={saving}
          >
            {saving ? (
              <Loading type="btn" size="small" text="Salvando..." />
            ) : (
              "Salvar"
            )}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  groups: {
    ...state.users.groups,
    data: UsersSelectors.groups(state.users.groups.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(UsersActions, dispatch);

export default connect(mapState, mapActions)(GroupForm);
